import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { safeReturnTo } from '../auth/returnTo';
import '../styles/AuthPage.css';
import logo from '../logo.png';

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const returnTo = safeReturnTo(useLocation().state?.from);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: signInError } = await signIn({ email, password, returnTo });
    setLoading(false);
    if (signInError) {
      // Only a real credential rejection from Supabase Auth is HTTP 400 /
      // invalid_credentials. Anything else (the backend on :3001 not running,
      // the /sb proxy unreachable, a 5xx) must NOT masquerade as a wrong
      // password, otherwise the user burns time on a correct password while
      // the real problem is the server being down.
      const badCreds = signInError.status === 400
        || signInError.code === 'invalid_credentials'
        || /invalid login credentials/i.test(signInError.message || '');
      setError(badCreds
        ? 'ایمیل یا رمز عبور نادرست است'
        : 'ارتباط با سرور برقرار نشد. مطمئن شوید سرور بک‌اند در حال اجراست و دوباره تلاش کنید');
      return;
    }
    // The page asked for before sign-in, else RootRedirect routes by role/status.
    navigate(returnTo || '/', { replace: true });
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <img src={logo} alt="لوگو سایت" className="auth-logo" />
        <h2>ورود به سامانه</h2>
        <div style={{ fontSize: 13, color: '#475569', marginBottom: 16 }}>حساب اپراتور / ادمین</div>
        <form className="auth-form-group" onSubmit={onSubmit}>
          <div className="auth-input-wrapper">
            <input className="auth-input" type="email" dir="ltr" placeholder="ایمیل"
              value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="auth-input-wrapper auth-input-wrapper--eye">
            <input className="auth-input" type={showPassword ? 'text' : 'password'} dir="ltr" placeholder="رمز عبور"
              value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button type="button" className="auth-input-eye"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'پنهان کردن رمز عبور' : 'نمایش رمز عبور'}>
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          {error && <div style={{ color: '#dc2626', fontSize: 13, margin: '6px 0' }}>{error}</div>}
          <button className="auth-button" type="submit" disabled={loading}>
            {loading ? 'در حال ورود…' : 'ورود'}
          </button>
        </form>
        <div style={{ marginTop: 14, fontSize: 13 }}>
          <Link to="/register" style={{ color: '#2563eb', fontWeight: 600 }}>حساب ندارید؟ ثبت‌نام کنید</Link>
        </div>
      </div>
    </div>
  );
}
